<footer class="footer ">
    <div class="container-fluid">        
        <div class="copyright pull-right">
            &copy;
            {{year | date: 'yyyy'}} Made by Fintegrate.
            {{version}}
        </div>
    </div>
</footer>
